import axios from "axios";
import {  BillingInfo, BillingInfoResponse, OrganizationResponse, TAddonsResponse,TInvoiceDetails,TInvoiceListResponse, TOverviewData, TPaymentCard, TPaymentDrawer, TPaymentMethodTab, TuploadResponse, subscriptionHistory } from "types/subscription";

export async function getOverviewData(): Promise<TOverviewData> {
  const {data} = await axios.get<TOverviewData>(`/tenant/subscriptions.json`);
  return data;
}
export async function getsubscriptionHistoryData():Promise<subscriptionHistory> {
  const {data} = await axios.get<subscriptionHistory>(`/tenant/subscription/history.json`);
  return data;
}
export async function getAddonsData():Promise<TAddonsResponse> {
  const {data} = await axios.get<TAddonsResponse>(`/tenant/subscription/addons.json`);
  return data;
}
export async function getPaymentMethodsData():Promise<TPaymentMethodTab> {
  const {data} = await axios.get<TPaymentMethodTab>(`/tenant/subscription/billing_details.json`);
  return data;
}
export async function makePaymentCardDefault(cardId: number | string):Promise<TPaymentCard> {
  const { data } = await axios.post<TPaymentCard>(`/tenant/subscription_billing_details/${cardId}/make_default`);
  return data;
}

export async function deletePaymentMethod(cardId: number): Promise<void> {
  const { data, status } = await axios.delete<void>(
    `/tenant/subscription_billing_details/${cardId}`,
    {
      validateStatus: () => true,
    }
  );

  if (status === 404) {
    window.location.reload();
  }
  return data;
}
export async function getBillingHistoryData(page:number,perPage:number):Promise<TInvoiceListResponse>  {
  const {data} = await axios.get<TInvoiceListResponse>(`/tenant/subscription/invoices.json?page=${page}&per_page=${perPage}`);

  return data;
}
export async function getListOfCardsData(): Promise<TPaymentDrawer> {
  const { data } = await axios.get<TPaymentDrawer>("/tenant/subscription/billing_details.json");
  return data;
}

const getPaymentURL = ({paymentMethod, cardId}: {paymentMethod: string | string[], cardId: number}) => {
  if (Array.isArray(paymentMethod)) {
    paymentMethod = paymentMethod[0];
  }
  switch (paymentMethod) {
    case "tamara":
    case "sadad":
      return "/tenant/subscription/payments/due_payment.json";
    case "credit-cards":
      return `/tenant/subscription/payments/${cardId}/recurring_payment.json`;
    default:
      return "";
  }
}
export async function payNowRequest(
  cardId: number,
  invoiceId: number,
  cardType: string,
  paymentMethod: string | string[],
  user_national_id?: string
) {
  const { data } = await axios.post<{
    message:
      | string
      | { checkout_url: string }
      | { SADADNumber: string; expiry_date: string };
  }>(getPaymentURL({ paymentMethod, cardId }), {
    invoice_id: invoiceId,
    card_type: cardType,
    user_national_id,
  });
  return data;
}

export async function getInvoiceDetailsData(id:number):Promise<TInvoiceDetails> {
  const {data} = await axios.get<TInvoiceDetails>(`/tenant/subscription/invoices/${id}.json`);
  return data;
}

export async function uploadBankTransferFiles(formData: FormData): Promise<TuploadResponse>  {
  const response = await axios.post(`/tenant/subscription/payments/bank_transfer.json`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data as TuploadResponse;
}

export async function getBillingInfoData():Promise<BillingInfoResponse>  {
  const {data} = await axios.get<BillingInfoResponse>(`/tenant/subscription/billing_info.json`);
  return data;
}

export async function updateBillingInfoData(data: BillingInfo): Promise<Record<string, any>>  {
  const {data: response} = await axios.post<Record<string, any>>(`/tenant/subscription/billing_info.json`, data);
  return response;
}

export async function getOrganizationList({
  page = 1,
  perPage = 10,
  filters = {},
}: {
  page?: number;
  perPage?: number;
  filters?: Record<string, string | number | undefined>;
} = {}) {
  const params = new URLSearchParams({
    page: page.toString(),
    per_page: perPage.toString(),
  });

  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    params.append(key, value.toString());
  });

  const { data: response } = await axios.get<OrganizationResponse>(
    `/tenant/dashboards/organizations.json?${params.toString()}`
  );
  
  return response;
}